<template>
  <v-container>
    <v-row align="center" class="align-center justify-center">
  <!--     <v-col
        v-for="(link, i) in links"
        :key="i"
        class="text-center"
        cols="6"
        md="auto"
      >
        <a
          :href="link.href"
          class="text-decoration-none font-weight-regular"
          rel="noopener"
          target="_blank"
          v-text="link.text"
        />
      </v-col>

      <v-spacer class="hidden-sm-and-down" /> -->

      <v-col
        cols="12"
        md="auto"
      >
        <div class=" font-weight-light pt-6 pt-md-0 text-center">
            <a
            href="https://fanavar.co"
            class="text-decoration-none"
            target="_blank"
          >
            <v-list-item-avatar>
                <v-img
                  :src="
                    require('../assets/Logo-Aarak.svg')"
                />
              </v-list-item-avatar>
          کلیه حقوق این سامانه متعلق به شرکت آراک فناوران برتر دانش می باشد
          &copy; {{ (new Date()).getFullYear() }}
          </a>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Links',

    data: () => ({
      links: [
        {
          href: 'https://fanavar.co/',
          text: 'آراک فناوران برتر دانش',
        },
        {
          href: '#',
          text: 'درباره ما',
        },
        {
          href: '#',
          text: 'بلاگ',
        }
      ],
    }),
  }
</script>

<style lang="sass" scoped>
  a
    color: inherit !important
</style>
